import { createFileRoute } from "@tanstack/react-router";

import { FriendInvitationPage } from "../../components/friend-invitation/friend-invitation-page";

export const Route = createFileRoute("/invite/$invitationCode")({
  component: FriendInvitationPage
});
